export default __webpack_public_path__ + "static/media/notFound.149a762d.gif";